import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  nestedSideMenuRoot: {
    backdropFilter: "blur(3px)",
  },
  fieldsContainer: {
    paddingTop: "16px",
  },
  fieldSection: {
    display: "flex",
    flexDirection: "column",
    padding: "24px",
    gap: "20px",
    marginBottom: "16px",
    width: "400px",
    borderRadius: "12px",
    boxShadow:
      "0px 2px 4px -2px rgba(16, 24, 40, 0.06), 0px 4px 8px -2px rgba(16, 24, 40, 0.10)",
    background: theme.palette.background.paper,
    [theme.breakpoints.down("960")]: {
      borderRadius: "none",
      boxShadow: "none",
      width: "100%",
      padding: "0px",
    },
  },
  fieldSectionHeader: {
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "28px",
    color: theme.palette.text.primary,
  },
  fieldSectionInputs: {
    gap: "6px",
    width: "100% !important",
    flexDirection: "column",
  },
  buttonContainer: {
    display: "flex",
    padding: "24px",
    gap: "20px",
    marginBottom: "16px",
    justifyContent: "flex-end",
    width: "400px",
    borderRadius: "12px",
    boxShadow:
      "0px 2px 4px -2px rgba(16, 24, 40, 0.06), 0px 4px 8px -2px rgba(16, 24, 40, 0.10)",
    background: theme.palette.background.paper,
    [theme.breakpoints.down("960")]: {
      display: "none",
    },
  },
}));
